import React from 'react';
import { Switch, Case, Default } from 'react-if';

import './styles.scss';

const LoadingLarge = (props) => {
  const { relative, customClassName } = props;

  return (
    <div
      className={`loading-spinner-container ${customClassName} ${relative &&
        'relative'}`}
    >
      <div className="lds-spinner">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

const LoadingWithText = (props) => {
  const { title } = props;

  return (
    <div className={`loading-spinner-with-text`}>
      <section className="spinner-with-text">
        <article className="lds-spinner">
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
        </article>

        <p className="lds-text">{title}</p>
      </section>
    </div>
  );
};

const LoadingSmall = (props) => {
  const { customClassName } = props;

  return (
    <div className={`loading-spinner-container-small ${customClassName}`}>
      <div className="loading-circle">
        <div className="inner-circle-1 inner-circle" />
        <div className="inner-circle-2 inner-circle" />
        <div className="inner-circle-3 inner-circle" />
        <div className="inner-circle-4 inner-circle" />
        <div className="inner-circle-5 inner-circle" />
        <div className="inner-circle-6 inner-circle" />
        <div className="inner-circle-7 inner-circle" />
        <div className="inner-circle-8 inner-circle" />
        <div className="inner-circle-9 inner-circle" />
        <div className="inner-circle-10 inner-circle" />
        <div className="inner-circle-11 inner-circle" />
        <div className="inner-circle-12 inner-circle" />
      </div>
    </div>
  );
};

const LoadingSpinner = (props) => {
  const { type } = props;

  return (
    <Switch>
      <Case condition={type === 'small'}>
        <LoadingSmall {...props} />
      </Case>

      <Case condition={type === 'text'}>
        <LoadingWithText {...props} />
      </Case>

      <Default>
        <LoadingLarge {...props} />
      </Default>
    </Switch>
  );
};

export default LoadingSpinner;
